// This optional code is used to register a service worker for PWA support.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export function register(config) {
  if (process.env.NODE_ENV !== 'production') {
    console.log('[SW] Service worker registration skipped (not production)');
    return;
  }

  if (!('serviceWorker' in navigator)) {
    console.log('[SW] Service workers are not supported');
    return;
  }

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    console.log('[SW] Public URL origin mismatch');
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      console.log('[SW] Localhost detected; checking service worker...');
      checkValidServiceWorker(swUrl, config);
    } else {
      registerValidSW(swUrl, config);
    }
  });
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('[SW] Registered:', registration.scope);
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log(
                'New content is available and will be used when all tabs are closed.'
              );
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log('Content is cached for offline use.');
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: {'Service-Worker': 'script'},
  })
    .then((response) => {
      if (response.status === 404) {
        console.log('[SW] No service worker found (404).');
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister();
        });
        return;
      }
      const contentType = response.headers.get('content-type');
      if (contentType != null && contentType.indexOf('javascript') === -1) {
        console.warn('[SW] Unexpected content type for service worker:', contentType);
        // Do NOT reload the page — just try registering anyway or skip.
        registerValidSW(swUrl, config);
        return;
      }
      registerValidSW(swUrl, config);
    })
    .catch((error) => {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
      console.error('[SW] Fetch error:', error);
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
